import { render, staticRenderFns } from "./group-transferCopy.vue?vue&type=template&id=3f2f84fe&"
import script from "./group-transferCopy.vue?vue&type=script&lang=js&"
export * from "./group-transferCopy.vue?vue&type=script&lang=js&"
import style0 from "./group-transferCopy.vue?vue&type=style&index=0&id=3f2f84fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports